import type { Plan } from '@/fixtures/plans';

export enum CreateAccountModalScreenName {
  Free = 'create-account-free',
  Premium = 'create-account-premium',
  Business = 'create-account-business',
  Essentials = 'create-account-essentials',
  Creator = 'create-account-creator',
  Pro = 'create-account-pro',
  WhatsYourThemeFree = 'create-account-whats-your-theme-free',
  WhatsYourThemePremium = 'create-account-whats-your-theme-premium',
  WhatsYourThemeBusiness = 'create-account-whats-your-theme-business',
  WhatsYourThemeEssentials = 'create-account-whats-your-theme-essentials',
  WhatsYourThemeCreator = 'create-account-whats-your-theme-creator',
  WhatsYourThemePro = 'create-account-whats-your-theme-pro',
  HowDidYouHearAboutUs = 'create-account-how-did-you-hear-about-us',
  WelcomeToUppbeat = 'create-account-welcome-to-uppbeat',
  SafelistPremium = 'create-account-safelist-premium',
  SafelistBusiness = 'create-account-safelist-business',
  SafelistEssentials = 'create-account-safelist-essentials',
  SafelistCreator = 'create-account-safelist-creator',
  SafelistPro = 'create-account-safelist-pro',
}

export enum AccountType {
  Free = 'free',
  Essentials = 'essentials',
  Creator = 'creator',
  Pro = 'pro',
  Business = 'business',
}

export const mapAccountTypeToSubscriptionType: Record<
  AccountType,
  Plan['name']
> = {
  [AccountType.Free]: 'Free',
  [AccountType.Essentials]: 'Essentials',
  [AccountType.Creator]: 'Creator',
  [AccountType.Pro]: 'Pro',
  [AccountType.Business]: 'Business',
};

export interface ContentType {
  icon: string;
  id: number;
  name: string;
  rank: number;
}

export interface VibeType {
  icon: string;
  id: number;
  name: string;
  rank: number;
}
